let svgNodeCache = {};
export function resetSvgNodeCache() {
    svgNodeCache = {};
}
export default svgNodeCache;
